import { render, staticRenderFns } from "./FidelityStats.vue?vue&type=template&id=0a9118ae&scoped=true"
import script from "./FidelityStats.vue?vue&type=script&lang=js"
export * from "./FidelityStats.vue?vue&type=script&lang=js"
import style0 from "./FidelityStats.vue?vue&type=style&index=0&id=0a9118ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9118ae",
  null
  
)

export default component.exports